import { UseAdyenApplePay } from './hooks/use-adyen-apple-pay';
import { AdyenComponentContainer } from '../../../AdyenPaymentElement/components/AdyenComponentContainer/AdyenComponentContainer';
import { AdyenThreeDSComponent } from '../../../AdyenPaymentElement/components/AdyenThreeDSContainer/AdyenThreeDSContainer';

import './styles.scss';

interface AdyenApplePayProps {
  onReady: (isAvailable: boolean) => void;
}

export function AdyenApplePay({ onReady }: AdyenApplePayProps) {
  const { applePay, threeDSComponent } = UseAdyenApplePay(onReady);

  if (!applePay) return null;

  return (
    <>
      <AdyenComponentContainer element={applePay} hideLoader />
      {threeDSComponent && <AdyenThreeDSComponent threeDSComponent={threeDSComponent} />}
    </>
  );
}
